export default __webpack_public_path__ + "static/media/thop-central-atendimento.45b5109a.png";